import React from 'react';
import SectionTag from '../components/SectionTag';
import ScrollReveal from '../components/ScrollReveal';
import StepCard from '../components/StepCard';

const NP_STEPS = [
  { number: '1', title: 'Sign Up on Dashboard', desc: 'Register your non-profit organization and get verified on the TCCplus platform.' },
  { number: '2', title: 'Complete Your Profile', desc: 'Add your organization details, contact info, and service areas.' },
  { number: '3', title: 'Post Resources & Events', desc: 'Create detailed listings with descriptions, banner images, dates and times.' },
  { number: '4', title: 'Respond to Inquiries', desc: 'Receive messages from people in need and respond directly through the platform.' },
  { number: '5', title: 'Track Your Impact', desc: 'View detailed reports and analytics on your reach and engagement.' },
];

const APP_STEPS = [
  { number: '1', title: 'Download the App', desc: 'Get the TCCplus People In Need app from the Google Play Store.' },
  { number: '2', title: 'Create Your Account', desc: 'Sign up in minutes with just your basic information.' },
  { number: '3', title: 'Browse Resources & Events', desc: 'Explore local non-profit resources and upcoming community events.' },
  { number: '4', title: 'View Full Details', desc: 'See complete event information including banner, description, date and time.' },
  { number: '5', title: 'Send an Inquiry', desc: 'Reach out directly to the non-profit with any questions before attending.' },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" style={{ background: '#F8FAFC', padding: '120px 5%', position: 'relative', overflow: 'hidden' }}>
      {/* ── 5. Ambient orbs ── */}
      <div className="amb-orb" style={{ width: '360px', height: '360px', top: '-80px', right: '-80px', background: 'radial-gradient(circle, rgba(63,196,227,0.1) 0%, transparent 70%)', filter: 'blur(50px)', animation: 'orb-drift 9s ease-in-out infinite', animationDelay: '-2s' }} />
      <div className="amb-orb" style={{ width: '280px', height: '280px', bottom: '-60px', left: '-60px', background: 'radial-gradient(circle, rgba(254,92,115,0.08) 0%, transparent 70%)', filter: 'blur(44px)', animation: 'orb-drift 12s ease-in-out infinite reverse' }} />
      <div className="max-w-screen-xl mx-auto" style={{ position: 'relative', zIndex: 1 }}>
        <div className="flex flex-col items-center text-center mb-16">
          <SectionTag label="HOW IT WORKS" />
          <h2 style={{ fontFamily: 'popinsBold', fontSize: 'clamp(28px, 4vw, 44px)', color: '#1B1A28', marginBottom: '12px' }}>
            Simple for Everyone
          </h2>
          <p style={{ fontFamily: 'popinsRegular', fontSize: '16px', color: '#6B7280' }}>
            Whether you're a non-profit or someone in need — TCCplus makes the process effortless.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Non-profit card */}
          <ScrollReveal direction="left" className="h-full">
            <div
              style={{
                background: '#ffffff',
                borderRadius: '20px',
                padding: '40px',
                border: '1px solid #E5E5E5',
                borderTop: '4px solid #3FC4E3',
                boxShadow: '0 4px 24px rgba(0,0,0,0.05)',
                height: '100%',
              }}
            >
              <h3 style={{ fontFamily: 'popinsSemiBold', fontSize: '22px', color: '#1B1A28', marginBottom: '32px' }}>
                For Non Profit 🏢
              </h3>
              {NP_STEPS.map((step, i) => (
                <StepCard key={step.number} number={step.number} title={step.title} description={step.desc} accentColor="#3FC4E3" isLast={i === NP_STEPS.length - 1} />
              ))}
            </div>
          </ScrollReveal>

          {/* App card */}
          <ScrollReveal direction="right" className="h-full">
            <div
              style={{
                background: '#ffffff',
                borderRadius: '20px',
                padding: '40px',
                border: '1px solid #E5E5E5',
                borderTop: '4px solid #FE5C73',
                boxShadow: '0 4px 24px rgba(0,0,0,0.05)',
                height: '100%',
              }}
            >
              <h3 style={{ fontFamily: 'popinsSemiBold', fontSize: '22px', color: '#1B1A28', marginBottom: '32px' }}>
                For People In Need 🤝
              </h3>
              {APP_STEPS.map((step, i) => (
                <StepCard key={step.number} number={step.number} title={step.title} description={step.desc} accentColor="#FE5C73" isLast={i === APP_STEPS.length - 1} />
              ))}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
